module.exports = __webpack_public_path__ + "static/media/update-password.55af82ac.webp";